import { storeToRefs } from 'pinia';
import Logged from './LoggedCom.vue';
import Logout from './LogoutCom.vue';
import service from '../../services';
import { useUserStore, useSecretStore } from '../../store';
import { getVisitorId } from '../../utils';

import { ref, unref, onMounted, onUnmounted, watch } from 'vue';
import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'LoginBox',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const useStore = useUserStore();

    // 是否登录
    const {
      isLogin,
      isSlideSync,
      isOutlineSync
    } = storeToRefs(useStore);

    // 用户信息
    const userId = ref(null);
    const useSecret = useSecretStore();

    // 获取用户登录信息
    const getAccountInfoSync = () => new Promise(resolve => {
      service.getAccountInfo().then(res => {
        if (res.code === 0) {
          useStore.changeLogin(true);
          userId.value = res.data.yduserid;
        } else {
          useStore.changeLogin(false);
          userId.value = null;
        }
      }).finally(() => {
        resolve(true);
      });
    });
    const nickname = ref('');
    // 获取用户昵称
    const getAccountNickname = () => {
      const params = {
        userid: unref(userId)
      };
      service.getNickname(params).then(res => {
        var _res$values;
        nickname.value = (_res$values = res.values) === null || _res$values === void 0 ? void 0 : _res$values.nickname;
      });
    };
    // 2024-08-08新增投放百度回调
    const baiduCallback = () => {
      const params = {
        loginUrl: window.location.href,
        type: 49 // 行为类型
      };
      service.baiduCallback(params);
    };
    // 是否展示登录组件
    const showLoginBox = ref(false);
    const {
      yduuid
    } = storeToRefs(useSecret);

    // 未登录用户获取 token
    const fetchToken = id => new Promise(resolve => {
      service.getToken({
        yduuid: id
      }).then(res => {
        if (res.code === 200) {
          useSecret.changeToken(res.data);
        } else {
          showToast({
            message: res.msg,
            className: 'c-toast'
          });
        }
      }).finally(() => {
        resolve(true);
      });
    });
    // 未登录用户获取浏览器指纹
    const getFingerprint = async () => {
      if (!unref(yduuid)) {
        const id = await getVisitorId();
        await fetchToken(id);
      }
    };
    const init = async () => {
      await getAccountInfoSync();
      // 未登录获取浏览器指纹，否则获取已登录用户的昵称
      if (!unref(isLogin) && !unref(yduuid)) {
        getFingerprint();
      } else {
        getAccountNickname();
      }
      showLoginBox.value = true;
      useStore.changeFetchLogin(true);
    };
    const onPageVisible = () => {
      document.addEventListener('visibilitychange', () => {
        // 回到tab页
        if (document.visibilityState === 'visible') {
          init();
        }
      });
    };
    const removePageVisible = () => {
      document.removeEventListener('visibilitychange');
    };
    onMounted(() => {
      onPageVisible();
      init();
      if (unref(isLogin)) {
        baiduCallback();
      }
    });
    onUnmounted(() => {
      removePageVisible();
    });
    watch([isSlideSync, isOutlineSync], (slideVal, outlineVal) => {
      // 当大纲和PPT都同步完成，重置token
      if (slideVal && outlineVal) {
        useSecret.changeYdId('');
        useSecret.changeToken('');
      }
    });
    const __returned__ = {
      useStore,
      isLogin,
      isSlideSync,
      isOutlineSync,
      userId,
      useSecret,
      getAccountInfoSync,
      nickname,
      getAccountNickname,
      baiduCallback,
      showLoginBox,
      yduuid,
      fetchToken,
      getFingerprint,
      init,
      onPageVisible,
      removePageVisible,
      get storeToRefs() {
        return storeToRefs;
      },
      Logged,
      Logout,
      get service() {
        return service;
      },
      get useUserStore() {
        return useUserStore;
      },
      get useSecretStore() {
        return useSecretStore;
      },
      get getVisitorId() {
        return getVisitorId;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};